/* ==========================================================================
   YİGİTFY YORUMLAR — panel yorumları + sipariş doğrulamalı yorum yazma
   Bağımlılık yok. theme.liquid her sayfada yükler; ilgili kökler yoksa
   ([data-yorumlar] / [data-yorum-yaz]) sessizce çıkar.

   Sözleşme (panel canlı):
   - GET  {endpoint}/api/kapida/{store}/yorumlar?urun={handle}
          → {"yorumlar":[{"ad","puan","metin","tarih","dogrulanmis"}],
             "ozet":{"adet":N,"ortalama10":47,"dagilim":{"5":n,...,"1":n}}}
   - GET  {endpoint}/api/kapida/{store}/yorum-baslat?t={token}
          → {"ok":true,"ad","siparis_no","urunler":[{"handle","baslik","gorsel"}],
             "yazilanlar":["handle",...]}  |  {"error":"..."} (401 geçersiz link)
   - POST {endpoint}/api/kapida/{store}/yorum  {"t","urun","ad","puan","metin"}
          → {"ok":true} | {"error"} (409 = bu ürüne zaten yorum yazılmış)

   GÜVENLİK: API'den gelen tüm metinler textContent ile basılır, asla
   innerHTML kullanılmaz. Yıldız/rozet SVG'leri Liquid'deki <template>
   iskeletlerinden klonlanır.
   ========================================================================== */
(function () {
  'use strict';

  var PAGE_SIZE = 6;
  var AYLAR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function cfgFrom(root) {
    return {
      endpoint: (root.getAttribute('data-endpoint') || '').replace(/\/+$/, ''),
      store: root.getAttribute('data-store') || '1'
    };
  }

  function getJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r
        .json()
        .catch(function () {
          return null;
        })
        .then(function (body) {
          return { res: r, body: body };
        });
    });
  }

  /** "2026-03-12" → "12 Mar 2026"; tanınmayan biçim olduğu gibi döner. */
  function fmtTarih(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || ''));
    if (!m) return String(s || '');
    var ay = AYLAR[parseInt(m[2], 10) - 1];
    if (!ay) return String(s);
    return parseInt(m[3], 10) + ' ' + ay + ' ' + m[1];
  }

  /** ortalama10 (örn. 47) → "4,7" */
  function fmtOrt(ort10) {
    var o = parseInt(ort10, 10) || 0;
    if (o < 0) o = 0;
    if (o > 50) o = 50;
    return Math.floor(o / 10) + ',' + (o % 10);
  }

  function clampPuan(p) {
    p = parseInt(p, 10) || 0;
    if (p < 0) p = 0;
    if (p > 5) p = 5;
    return p;
  }

  /** container içine n dolu + (5-n) boş yıldız klonlar (template'lerden). */
  function drawStars(container, n, tplFull, tplEmpty) {
    if (!container || !tplFull || !tplEmpty) return;
    n = clampPuan(n);
    container.textContent = '';
    for (var i = 1; i <= 5; i++) {
      var tpl = i <= n ? tplFull : tplEmpty;
      container.appendChild(tpl.content.cloneNode(true));
    }
  }

  /* ========================================================================
     MODÜL 1 — ÜRÜN SAYFASI YORUMLARI (sections/yorumlar.liquid hidrasyonu)
     API'de yorum varsa Liquid yer tutucular API verisiyle değiştirilir;
     yoksa/başarısızsa yer tutucular aynen kalır.
     ======================================================================== */
  function initYorumlar() {
    var root = $('[data-yorumlar]');
    if (!root || root.getAttribute('data-yrev-ready') === '1') return;
    var cfg = cfgFrom(root);
    var urun = root.getAttribute('data-urun') || '';
    if (!cfg.endpoint || !urun) return;
    root.setAttribute('data-yrev-ready', '1');

    getJson(
      cfg.endpoint +
        '/api/kapida/' +
        encodeURIComponent(cfg.store) +
        '/yorumlar?urun=' +
        encodeURIComponent(urun)
    )
      .then(function (out) {
        var d = out.body;
        if (
          !out.res.ok ||
          !d ||
          !d.ozet ||
          !(parseInt(d.ozet.adet, 10) > 0) ||
          !Array.isArray(d.yorumlar) ||
          !d.yorumlar.length
        ) {
          return; // yer tutucular kalır
        }
        renderYorumlar(root, d);
      })
      .catch(function () {
        // API erişilemedi — yer tutucular kalır, sayfa etkilenmez.
      });
  }

  function renderYorumlar(root, d) {
    var tplFull = $('template[data-yrev-tpl-star]', root);
    var tplEmpty = $('template[data-yrev-tpl-star-empty]', root);
    var tplCard = $('template[data-yrev-tpl-card]', root);
    var grid = $('[data-yrev-grid]', root);
    if (!tplCard || !grid) return;

    var adet = parseInt(d.ozet.adet, 10) || d.yorumlar.length;

    /* --- özet paneli --- */
    var avgEl = $('[data-yrev-avg]', root);
    if (avgEl) avgEl.textContent = fmtOrt(d.ozet.ortalama10);
    drawStars(
      $('[data-yrev-avg-stars]', root),
      Math.round((parseInt(d.ozet.ortalama10, 10) || 0) / 10),
      tplFull,
      tplEmpty
    );
    var countEl = $('[data-yrev-count]', root);
    if (countEl) countEl.textContent = adet + ' değerlendirme';

    var dagilim = d.ozet.dagilim || {};
    for (var p = 1; p <= 5; p++) {
      var n = parseInt(dagilim[String(p)], 10) || 0;
      var bar = $('[data-yrev-bar="' + p + '"]', root);
      var cnt = $('[data-yrev-bar-count="' + p + '"]', root);
      if (bar) bar.style.width = (adet > 0 ? Math.round((n * 100) / adet) : 0) + '%';
      if (cnt) cnt.textContent = String(n);
    }

    /* --- kartlar (6'şar sayfalı) --- */
    grid.textContent = '';
    var shown = 0;
    var list = d.yorumlar;
    var moreWrap = $('[data-yrev-more-wrap]', root);
    var moreBtn = $('[data-yrev-more]', root);

    function buildCard(y) {
      var frag = tplCard.content.cloneNode(true);
      var card = frag.firstElementChild;
      drawStars($('[data-tpl-stars]', card), y.puan, tplFull, tplEmpty);
      var starsEl = $('[data-tpl-stars]', card);
      if (starsEl) {
        starsEl.setAttribute('role', 'img');
        starsEl.setAttribute('aria-label', '5 üzerinden ' + clampPuan(y.puan) + ' yıldız');
      }
      $('[data-tpl-text]', card).textContent = String(y.metin || '');
      $('[data-tpl-name]', card).textContent = String(y.ad || '');
      var badge = $('[data-tpl-badge]', card);
      if (badge && !y.dogrulanmis) badge.parentNode.removeChild(badge);
      var dateEl = $('[data-tpl-date]', card);
      if (dateEl) {
        if (y.tarih) dateEl.textContent = fmtTarih(y.tarih);
        else dateEl.parentNode.removeChild(dateEl);
      }
      return card;
    }

    function renderMore() {
      var end = Math.min(shown + PAGE_SIZE, list.length);
      for (var i = shown; i < end; i++) grid.appendChild(buildCard(list[i]));
      shown = end;
      if (moreWrap) moreWrap.hidden = shown >= list.length;
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', renderMore);
    }
    renderMore();

    // Bölüm Liquid'de gizliyse (yer tutucu yokken) görünür yap; reveal
    // animasyonu gözlemcisi dinamik içeriği tanımaz — doğrudan görünür kıl.
    root.hidden = false;
    $$('.reveal', root).forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ========================================================================
     MODÜL 2 — YORUM YAZ SAYFASI (sections/yorum-yaz.liquid)
     ?t=TOKEN ile açılır; yorum-baslat ile sipariş doğrulanır, ürün seçilir,
     yorum POST edilir. Token yok/geçersiz → zarif kapı ekranı.
     ======================================================================== */
  var W = null;

  function initYorumYaz() {
    var root = $('[data-yorum-yaz]');
    if (!root) {
      W = null;
      return;
    }
    if (W && W.root === root) return;

    var cfg = cfgFrom(root);
    W = {
      root: root,
      cfg: cfg,
      token: readToken(),
      data: null,
      written: {},
      current: null,
      submitting: false,
      adTouched: false,
      loading: $('[data-yw-loading]', root),
      error: $('[data-yw-error]', root),
      main: $('[data-yw-main]', root),
      greet: $('[data-yw-greet]', root),
      orderline: $('[data-yw-orderline]', root),
      products: $('[data-yw-products]', root),
      tplProduct: $('template[data-yw-tpl-product]', root),
      form: $('[data-yw-form]', root),
      fpImg: $('[data-yw-fp-img]', root),
      fpTitle: $('[data-yw-fp-title]', root),
      backBtn: $('[data-yw-back]', root),
      starWrap: $('[data-yw-stars]', root),
      starRadios: $$('[data-yw-puan]', root),
      starLabels: $$('[data-yw-star]', root),
      starHint: $('[data-yw-star-hint]', root),
      adInput: $('[data-yw-ad]', root),
      metinInput: $('[data-yw-metin]', root),
      counter: $('[data-yw-count]', root),
      alert: $('[data-yw-alert]', root),
      submitBtn: $('[data-yw-submit]', root),
      success: $('[data-yw-success]', root),
      nextBtn: $('[data-yw-next]', root)
    };

    bindForm();
    start();
  }

  function readToken() {
    try {
      return new URLSearchParams(window.location.search).get('t') || '';
    } catch (e) {
      var m = /[?&]t=([^&#]+)/.exec(window.location.search);
      return m ? decodeURIComponent(m[1]) : '';
    }
  }

  function ywShow(el) {
    if (el) el.hidden = false;
  }
  function ywHide(el) {
    if (el) el.hidden = true;
  }

  function showGate() {
    ywHide(W.loading);
    ywHide(W.main);
    ywHide(W.form);
    ywHide(W.success);
    ywShow(W.error);
  }

  function start() {
    if (!W.cfg.endpoint || !W.token) {
      showGate();
      return;
    }
    getJson(
      W.cfg.endpoint +
        '/api/kapida/' +
        encodeURIComponent(W.cfg.store) +
        '/yorum-baslat?t=' +
        encodeURIComponent(W.token)
    )
      .then(function (out) {
        var d = out.body;
        if (!out.res.ok || !d || !d.ok || !Array.isArray(d.urunler) || !d.urunler.length) {
          showGate();
          return;
        }
        W.data = d;
        (d.yazilanlar || []).forEach(function (h) {
          W.written[String(h)] = true;
        });
        buildMain();
      })
      .catch(showGate);
  }

  function buildMain() {
    ywHide(W.loading);
    var ad = String(W.data.ad || '').trim();
    if (W.greet) W.greet.textContent = ad ? 'Merhaba ' + ad + '!' : 'Merhaba!';
    if (W.orderline) {
      var no = String(W.data.siparis_no || '').trim();
      W.orderline.textContent = no
        ? no + ' numaralı siparişini değerlendir'
        : 'Siparişini değerlendir';
    }
    renderProducts();
    ywShow(W.main);

    // Tek ürünlü siparişte seçim adımını atla, formu doğrudan aç.
    var kalan = remaining();
    if (W.data.urunler.length === 1 && kalan.length === 1) {
      openForm(kalan[0]);
    }
  }

  function remaining() {
    return W.data.urunler.filter(function (u) {
      return !W.written[String(u.handle)];
    });
  }

  function renderProducts() {
    if (!W.products || !W.tplProduct) return;
    W.products.textContent = '';
    W.data.urunler.forEach(function (u) {
      var frag = W.tplProduct.content.cloneNode(true);
      var btn = frag.firstElementChild;
      var img = $('.yw__product-img', btn);
      if (img) {
        var src = String(u.gorsel || '');
        if (src) img.src = src;
        else img.hidden = true; // görsel yoksa kırık resim kutusu gösterme
        img.alt = String(u.baslik || '');
      }
      $('[data-tpl-title]', btn).textContent = String(u.baslik || '');
      var cta = $('[data-tpl-cta]', btn);
      var done = $('[data-tpl-done]', btn);
      if (W.written[String(u.handle)]) {
        btn.disabled = true;
        if (cta) cta.hidden = true;
        if (done) done.hidden = false;
      } else {
        btn.addEventListener('click', function () {
          openForm(u);
        });
      }
      W.products.appendChild(btn);
    });
  }

  /* ------------------------------------------------------------- form */

  function bindForm() {
    if (!W.form) return;
    W.form.addEventListener('submit', onSubmit);

    if (W.backBtn) {
      W.backBtn.addEventListener('click', function () {
        ywHide(W.form);
        ywShow(W.main);
      });
    }
    if (W.nextBtn) {
      W.nextBtn.addEventListener('click', function () {
        var kalan = remaining();
        if (kalan.length) {
          ywHide(W.success);
          openForm(kalan[0]);
        }
      });
    }

    // Yıldızlar: seçim + hover ön izleme
    W.starRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        paintStars(parseInt(r.value, 10));
        setErr('puan', '');
      });
    });
    W.starLabels.forEach(function (lab) {
      lab.addEventListener('mouseenter', function () {
        paintStars(parseInt(lab.getAttribute('data-yw-star'), 10), true);
      });
    });
    if (W.starWrap) {
      W.starWrap.addEventListener('mouseleave', function () {
        paintStars(selectedPuan());
      });
    }

    if (W.metinInput && W.counter) {
      W.metinInput.addEventListener('input', function () {
        W.counter.textContent = String(W.metinInput.value.length);
      });
    }
    if (W.adInput) {
      W.adInput.addEventListener('input', function () {
        W.adTouched = true;
      });
    }
  }

  var HINTS = { 1: 'Çok kötü', 2: 'Kötü', 3: 'İdare eder', 4: 'İyi', 5: 'Mükemmel' };

  function paintStars(n, preview) {
    n = clampPuan(n);
    W.starLabels.forEach(function (lab) {
      var i = parseInt(lab.getAttribute('data-yw-star'), 10);
      lab.classList.toggle('is-on', i <= n);
    });
    if (W.starHint) {
      W.starHint.textContent = n > 0 ? HINTS[n] : '';
      if (preview) W.starHint.setAttribute('data-preview', '1');
      else W.starHint.removeAttribute('data-preview');
    }
  }

  function selectedPuan() {
    var v = 0;
    W.starRadios.forEach(function (r) {
      if (r.checked) v = parseInt(r.value, 10);
    });
    return v;
  }

  function openForm(u) {
    W.current = u;
    if (W.fpImg) {
      var src = String(u.gorsel || '');
      if (src) {
        W.fpImg.src = src;
        W.fpImg.hidden = false;
      } else {
        W.fpImg.removeAttribute('src');
        W.fpImg.hidden = true;
      }
      W.fpImg.alt = String(u.baslik || '');
    }
    if (W.fpTitle) W.fpTitle.textContent = String(u.baslik || '');
    if (W.backBtn) W.backBtn.hidden = W.data.urunler.length < 2;

    W.starRadios.forEach(function (r) {
      r.checked = false;
    });
    paintStars(0);
    if (W.adInput && (!W.adTouched || !W.adInput.value.trim())) {
      W.adInput.value = String(W.data.ad || '');
    }
    if (W.metinInput) W.metinInput.value = '';
    if (W.counter) W.counter.textContent = '0';
    clearAlert();
    ['puan', 'ad', 'metin'].forEach(function (k) {
      setErr(k, '');
    });

    ywHide(W.main);
    ywHide(W.success);
    ywShow(W.form);
    try {
      W.form.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } catch (e) {}
  }

  function setErr(name, msg) {
    var el = $('[data-yw-err="' + name + '"]', W.root);
    if (el) {
      el.textContent = msg || '';
      el.hidden = !msg;
    }
    var control = name === 'ad' ? W.adInput : name === 'metin' ? W.metinInput : null;
    if (control) {
      control.classList.toggle('is-invalid', !!msg);
      if (msg) control.setAttribute('aria-invalid', 'true');
      else control.removeAttribute('aria-invalid');
    }
  }

  function clearAlert() {
    if (!W.alert) return;
    W.alert.hidden = true;
    W.alert.textContent = '';
    W.alert.classList.remove('yw__alert--info');
  }

  function showFormAlert(msg, info) {
    if (!W.alert) return;
    W.alert.textContent = msg;
    W.alert.classList.toggle('yw__alert--info', !!info);
    W.alert.hidden = false;
    try {
      W.alert.scrollIntoView({ block: 'nearest' });
    } catch (e) {}
  }

  function validate() {
    var ok = true;

    var puan = selectedPuan();
    if (puan < 1 || puan > 5) {
      setErr('puan', 'Yıldızlara dokunarak puanını ver.');
      ok = false;
    } else {
      setErr('puan', '');
    }

    var ad = (W.adInput ? W.adInput.value : '').trim().replace(/\s+/g, ' ');
    if (ad.length < 2 || ad.length > 80) {
      setErr('ad', 'Adını yaz.');
      ok = false;
    } else {
      setErr('ad', '');
    }

    var metin = (W.metinInput ? W.metinInput.value : '').trim();
    if (metin.length < 10) {
      setErr('metin', 'Yorumun en az 10 karakter olmalı — bir iki cümle yeter.');
      ok = false;
    } else if (metin.length > 1000) {
      setErr('metin', 'Yorumun en fazla 1000 karakter olabilir.');
      ok = false;
    } else {
      setErr('metin', '');
    }

    if (!ok) return null;
    return { puan: puan, ad: ad, metin: metin };
  }

  function onSubmit(e) {
    e.preventDefault();
    if (!W || W.submitting || !W.current) return;
    clearAlert();

    var v = validate();
    if (!v) return;

    W.submitting = true;
    if (W.submitBtn) {
      W.submitBtn.classList.add('is-loading');
      W.submitBtn.setAttribute('aria-disabled', 'true');
    }

    fetch(W.cfg.endpoint + '/api/kapida/' + encodeURIComponent(W.cfg.store) + '/yorum', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        t: W.token,
        urun: String(W.current.handle),
        ad: v.ad,
        puan: v.puan,
        metin: v.metin
      })
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () {
            return null;
          })
          .then(function (body) {
            return { res: r, body: body };
          });
      })
      .then(function (out) {
        doneSubmitting();
        if (out.res.ok && out.body && out.body.ok) {
          onWriteSuccess();
          return;
        }
        if (out.res.status === 409) {
          // Bu ürüne zaten yorum yazılmış — nazikçe bildir, ürünü kapat.
          W.written[String(W.current.handle)] = true;
          renderProducts();
          showFormAlert('Bu ürün için yorumunu daha önce almışız — teşekkürler! Dilersen diğer ürününü değerlendirebilirsin.', true);
          if (W.backBtn) W.backBtn.hidden = false;
          return;
        }
        var msg = (out.body && (out.body.error || out.body.mesaj)) || '';
        showFormAlert(msg || 'Yorumun gönderilemedi. Bağlantını kontrol edip tekrar dener misin?');
      })
      .catch(function () {
        doneSubmitting();
        showFormAlert('Yorumun gönderilemedi. Bağlantını kontrol edip tekrar dener misin?');
      });
  }

  function doneSubmitting() {
    W.submitting = false;
    if (W.submitBtn) {
      W.submitBtn.classList.remove('is-loading');
      W.submitBtn.removeAttribute('aria-disabled');
    }
  }

  function onWriteSuccess() {
    W.written[String(W.current.handle)] = true;
    renderProducts();
    ywHide(W.form);
    var kalan = remaining();
    if (W.nextBtn) W.nextBtn.hidden = !kalan.length;
    ywShow(W.success);
    if (W.success && W.success.focus) W.success.focus();
  }

  /* ========================================================================
     MODÜL 3 — BAŞLIK ÜSTÜ PUAN ROZETİ (main-product.liquid [data-pdp-rating])
     Aynı yorum ucundan beslenir (yanıt 5 dk public cache'li — bölümle aynı
     URL olduğundan ikinci istek tarayıcı önbelleğinden döner). Yorum yoksa
     rozet hidden kalır. Tıklama Yorumlar bölümüne kaydırır.
     ======================================================================== */
  function initPuanRozeti() {
    var badge = $('[data-pdp-rating]');
    if (!badge || badge.getAttribute('data-yrev-ready') === '1') return;
    var cfg = cfgFrom(badge);
    var urun = badge.getAttribute('data-urun') || '';
    if (!cfg.endpoint || !urun) return;
    badge.setAttribute('data-yrev-ready', '1');

    getJson(
      cfg.endpoint +
        '/api/kapida/' +
        encodeURIComponent(cfg.store) +
        '/yorumlar?urun=' +
        encodeURIComponent(urun)
    )
      .then(function (out) {
        var d = out.body;
        if (!out.res.ok || !d || !d.ozet || !(parseInt(d.ozet.adet, 10) > 0)) return;
        var ort10 = parseInt(d.ozet.ortalama10, 10) || 0; // 0-50
        var fill = $('[data-pdp-rating-fill]', badge);
        if (fill) fill.style.width = Math.max(0, Math.min(100, ort10 * 2)) + '%';
        var scoreEl = $('[data-pdp-rating-score]', badge);
        if (scoreEl) scoreEl.textContent = fmtOrt(ort10);
        var countEl = $('[data-pdp-rating-count]', badge);
        if (countEl) countEl.textContent = '(' + (parseInt(d.ozet.adet, 10) || 0) + ' değerlendirme)';
        badge.hidden = false;
      })
      .catch(function () {
        // API yoksa rozet gizli kalır.
      });

    badge.addEventListener('click', function () {
      var hedef = $('[data-yorumlar]');
      if (hedef) hedef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ------------------------------------------------------------- giriş */

  function init() {
    initYorumlar();
    initYorumYaz();
    initPuanRozeti();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Tema editörü bölümü yeniden yüklerse elemanları tazele
  document.addEventListener('shopify:section:load', init);
})();
